var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5H36.5C38.7091 0.5 40.5 2.29086 40.5 4.5V38.5C40.5 40.7091 38.7091 42.5 36.5 42.5H4.5C2.29086 42.5 0.5 40.7091 0.5 38.5V4.5Z",
    fill: "#E5EDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5H36.5C38.7091 0.5 40.5 2.29086 40.5 4.5V38.5C40.5 40.7091 38.7091 42.5 36.5 42.5H4.5C2.29086 42.5 0.5 40.7091 0.5 38.5V4.5Z",
    stroke: "#DBDBDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5C9.5 7.39543 10.3954 6.5 11.5 6.5H22.6716C23.202 6.5 23.7107 6.71071 24.0858 7.08579L30.9142 13.9142C31.2893 14.2893 31.5 14.798 31.5 15.3284V34.5C31.5 35.6046 30.6046 36.5 29.5 36.5H11.5C10.3954 36.5 9.5 35.6046 9.5 34.5V8.5Z",
    fill: "#518FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.3281H24.6719L31.5 20.4997V15.3281Z",
    fill: "#518FF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.3281H24.6719L31.5 20.4997V15.3281Z",
    fill: "#383838",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9145 13.9142L24.0861 7.08579C23.711 6.71071 23.2023 6.5 22.6719 6.5V13.3284C22.6719 14.433 23.5673 15.3284 24.6719 15.3284H31.5003C31.5003 14.798 31.2896 14.2893 30.9145 13.9142Z",
    fill: "#92BBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 29.7998C23.3876 29.7998 23.7012 30.1134 23.7012 30.5C23.7012 30.8866 23.3876 31.2002 23.001 31.2002H15.001C14.6144 31.2002 14.3008 30.8866 14.3008 30.5C14.3008 30.1134 14.6144 29.7998 15.001 29.7998H23.001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 26.7998C26.3876 26.7998 26.7012 27.1134 26.7012 27.5C26.7012 27.8866 26.3876 28.2002 26.001 28.2002H15.001C14.6144 28.2002 14.3008 27.8866 14.3008 27.5C14.3008 27.1134 14.6144 26.7998 15.001 26.7998H26.001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 24.2998C26.3876 24.2998 26.7012 24.6134 26.7012 25C26.7012 25.3866 26.3876 25.7002 26.001 25.7002H15.001C14.6144 25.7002 14.3008 25.3866 14.3008 25C14.3008 24.6134 14.6144 24.2998 15.001 24.2998H26.001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 21.2998C26.3876 21.2998 26.7012 21.6134 26.7012 22C26.7012 22.3866 26.3876 22.7002 26.001 22.7002H15.001C14.6144 22.7002 14.3008 22.3866 14.3008 22C14.3008 21.6134 14.6144 21.2998 15.001 21.2998H26.001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDetailsIcon);
export default __webpack_public_path__ + "static/media/additionalDetailsIcon.dcb6bad4cd7943362f0952a099366f75.svg";
export { ForwardRef as ReactComponent };